import React, { Fragment } from 'react'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { obtenerUsuariosOCExportacion, obtenerUsuariosOCNacional } from '../../../../redux/DuckOrganismoCertificacion/GenerarUsuariosDuck';
import { actualizarFC01_OCAccion, agregarFC01_OCAccion } from '../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { obtenerSolicitudesFC01RevicionNacionalAdmin, obtenerSolicitudesFC01RevisionNacionalAuxiliar, obtenerSolicitudesUIFC01EstatusAdminRecibidas, obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas } from '../../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: 'fit-content',
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 3,
    p: 3,
    opacity: 1,
    borderRadius: '5px'
};
const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: 'fit-content',
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 3,
    p: 3,
    opacity: 1,
    borderRadius: '5px'
};
import { useHistory } from 'react-router-dom';
function ModalAsignarReasignarComponent(props) {
    const history = useHistory();
    const data = props?.data
    const dispatch = useDispatch()
    const usuarios = useSelector(store => store.GenerarUsuarios.usuarios)
    const [openModal, setOpenModal] = React.useState(true);
    const dataUser = useSelector(store => store.Usuario.user)

    const handleCloseModal = () => {
        setOpenModal(false)
        props.setOpenModal(false)
    }

    React.useEffect(async () => {
        await dispatch(obtenerUsuariosOCExportacion(8))
    }, [])

    const columns = [
        { field: 'Usuario', headerName: 'Usuario', headerAlign: 'center', flex: 1 },
        {
            field: 'Accion', headerName: 'Acción', headerAlign: 'center', flex: .3,
            renderCell: (params) =>
                <button onClick={() => handleOpenModal(params)} className='btn btn-danger'>Asignar</button>
        },
    ]

    const rows = []
    usuarios?.map(usuario => rows.push({ id: uuidv4(), Usuario: usuario?.usuario }))

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const Asignacion = async () => {
        if (data?.data?.ocsolicitudfc01?.length == 0) {
            let dataAsignacion = {
                idsolicitudesuifc01: data?.idsolicitudesuifc01, revisor: revisor, idcliente: data.idcliente
            }
            await dispatch(agregarFC01_OCAccion(dataAsignacion))
            handleCloseModal()
            if (history?.location?.pathname == '/SolicitudesOrganismoComponent' && dataUser?.[0]?.idrol == 1) {
                await dispatch(obtenerSolicitudesUIFC01EstatusAdminRecibidas(5))
                //props.history.push('/SolicitudesOrganismoComponent')
            } else {
                await dispatch(obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas(dataUser?.[0].usuario))
                //props.history.push('/SolicitudesOrganismoComponent')
            }
            if (history?.location?.pathname == '/SolicitudesRevisionOCUIComponent' && dataUser?.[0]?.idrol == 1) {
                await dispatch(obtenerSolicitudesFC01RevicionNacionalAdmin(1))
                //props.history.push('/SolicitudesRevisionOCUIComponent')
            } else {
                await dispatch(obtenerSolicitudesFC01RevisionNacionalAuxiliar(dataUser?.[0].usuario))
                //props.history.push('/SolicitudesOrganismoComponent')
            }
        } else {
            let dataAsignacion = {
                idsolicitudesuifc01: data?.idsolicitudesuifc01, revisor: revisor,
                idsolicitudesocfc01: data?.data?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                idcliente: data.idcliente
            }
            await dispatch(actualizarFC01_OCAccion(dataAsignacion))
            handleCloseModal()
            if (history?.location?.pathname == '/SolicitudesOrganismoComponent' && dataUser?.[0]?.idrol == 1) {
                await dispatch(obtenerSolicitudesUIFC01EstatusAdminRecibidas(5))
                //props.history.push('/SolicitudesOrganismoComponent')
            } else {
                await dispatch(obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas(dataUser?.[0].usuario))
                //props.history.push('/SolicitudesOrganismoComponent')
            }
            if (history?.location?.pathname == '/SolicitudesRevisionOCUIComponent' && dataUser?.[0]?.idrol == 1) {
                await dispatch(obtenerSolicitudesFC01RevicionNacionalAdmin(1))
                //props.history.push('/SolicitudesRevisionOCUIComponent')
            } else {
                await dispatch(obtenerSolicitudesFC01RevisionNacionalAuxiliar(dataUser?.[0].usuario))
                //props.history.push('/SolicitudesOrganismoComponent')
            }
        }
    }






    const [openModalAdv, setOpenModalAdv] = React.useState(false);
    const [revisor, setRevisor] = React.useState(false);
    const handleOpenModal = (params) => {
        setOpenModalAdv(true)
        setRevisor(params?.row?.Usuario)
    }
    const handleCloseModalAdv = () => {
        setOpenModalAdv(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModalAdv} onClose={handleCloseModalAdv} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" >
                    <Box sx={style1}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>Advertencia</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2, textAlign: 'center' }}>
                            Desea asignar a la solicitud al usuario {revisor} <br />
                            <strong>¿Desea continuar?</strong>
                            <br />
                            <div className='row'>
                                <div className='col-5'>
                                    <button className='btn btn-success' onClick={() => { Asignacion() }}>CONTINUAR</button>
                                </div>
                                <div className='col-2'></div>
                                <div className={`col-5`}>
                                    <button className='btn btn-danger' onClick={() => { handleCloseModalAdv() }}>CANCELAR</button>
                                </div>
                            </div>
                        </Typography>

                    </Box>
                </Modal>
            </div>
        )
    }






    return (
        <Fragment>
            <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h5" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center', fontWeight: 'bold' }}>
                        Auxiliares División Exportación
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
                        <div className='container'>
                            <Box sx={{ height: 300, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={10}
                                    getRowHeight={() => 'auto'}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        fontFamily: 'Montserrat',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                            padding: '1%'
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#7D9A47',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </div>
                    </Typography>
                    <ThemeProvider theme={theme}>
                        <div className='col-12 col-md-12 d-flex justify-content-center'>
                            <Button variant="contained" color="secondary" style={{ width: '50%' }} onClick={() => { handleCloseModal() }}>Cerrar</Button>
                        </div>
                    </ThemeProvider>
                </Box>
            </Modal>
            {modalComponent()}
        </Fragment>
    )
}
export default ModalAsignarReasignarComponent